import { render, staticRenderFns } from "./JVxeNormalCell.vue?vue&type=template&id=39763bc6&scoped=true"
import script from "./JVxeNormalCell.vue?vue&type=script&lang=js"
export * from "./JVxeNormalCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39763bc6",
  null
  
)

export default component.exports